module.exports = __webpack_public_path__ + "img/isola_cropped.2ae8d5af.png";